const mainColors = {
  primary: '#008080',
  purple: '#8f61d2',
  brown: '#8d6e63',
  pink: '#d63c70',
  neutral: '#b5bcc7',
  success: '#579b52',
  warning: '#cf8b2c',
  danger: '#bf564f',
  info: '#4b8fc3',
};

const lightStatusColors = {
  success: '#579b52',
  danger: '#bf564f',
  warning: '#cf8b2c',
  brown: '#8d6e63',
};

const darkStatusColors = {
  success: '#579b52',
  danger: '#d16a63',
  warning: '#cf8b2c',
  brown: '#8d6e63',
};

export const colors = {
  light: {
    bg: '#f7f9fc',
    surface: '#ffffff',
    surfaceAlt: '#f1f3f6',
    text: 'rgba(0, 0, 0, 0.87)',
    textMuted: 'rgba(0, 0, 0, 0.6)',
    border: 'rgba(0, 0, 0, 0.14)',
    divider: 'rgba(0, 0, 0, 0.14)',
    ...mainColors,
    ...lightStatusColors,
  },
  dark: {
    bg: '#161618',
    surface: '#202025',
    surfaceAlt: '#1c1c1f',
    text: '#FFFFFF',
    textMuted: 'rgba(255, 255, 255, 0.7)',
    border: 'rgba(255, 255, 255, 0.08)',
    divider: 'rgba(255, 255, 255, 0.08)',
    ...mainColors,
    ...darkStatusColors,
  },
} as const;

export type ColorMode = keyof typeof colors;
